import React from 'react'
import {EventText} from '../../../../../../commons/components/event-text'
import {useEventDateInformation} from '../../../../../../commons/hooks/dates'
import s from './date.scss'
import {DateProps} from './interfaces'

export const Date = ({event}: DateProps) => {
  const {shortStartDate} = useEventDateInformation(event.event.id)

  return (
    <div className={s.date}>
      <EventText>{shortStartDate}</EventText>
    </div>
  )
}
